export default "__VITE_ASSET__r0$5FpzA__"